/**
 * DealActivitiesTab - Aba de atividades (versão premium)
 * Exibe apenas a timeline de atividades
 * Formulário removido - atividades são criadas pelos ícones de atalho
 * 
 * Versão: 2.3.0
 * RELEASE: 2026-01-10 - Usa TimelineContainer para consistência visual
 */
import React from 'react';
import { DealActivityTimelinePremium } from '../components/DealActivityTimelinePremium';
import { DealInlineActivityCreator } from '../components/DealInlineActivityCreator';
import { TimelineContainer } from '@/components/crm/TimelineContainer';

// Props do componente
interface DealActivitiesTabProps {
  dealId: string;
  isOpen: boolean;
  isActive?: boolean; // Para lazy loading
  /** Permite criação inline de atividades (false quando deal fechado) */
  canCreate?: boolean;
}

/**
 * Aba de atividades - exibe criador inline + timeline
 * Usa TimelineContainer com showCard e title para manter o padrão visual
 */
export function DealActivitiesTab({ dealId, isOpen, isActive, canCreate = true }: DealActivitiesTabProps) {
  return (
    <TimelineContainer title="Histórico" showCard>
      <div className="space-y-3">
        {/* Criador inline no topo da timeline — mesma UX do modal de tarefas */}
        <DealInlineActivityCreator dealId={dealId} canCreate={canCreate} />
        <DealActivityTimelinePremium dealId={dealId} isActive={isActive} paginated />
      </div>
    </TimelineContainer>
  );
}
